import React from 'react';

const InstructionsIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="#000000"
		strokeWidth="2"
		strokeLinecap="butt"
		strokeLinejoin="arcs"
	>
		<path d="M17 9.5H3M21 4.5H3M21 14.5H3M17 19.5H3" />
	</svg>
);

// SelectMultipleIcon component
const SelectMultipleIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="Edit / Select_Multiple">
			<path
				id="Vector"
				d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M17 8L13 12L11 10M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z"
				stroke="#000000"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);

// NewIcon component
const Intro = () => (
	<svg
		fill="#000000"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 52 52"
		enableBackground="new 0 0 52 52"
	>
		<path
			d="M44,30.5c0,0,0.1,1.6-1.5,1.6H15.2c-0.9,0-1.3-1.2-0.7-1.8l5.6-5.6c0.6-0.6,0.6-1.5,0-2.1L18,20.5
        c-0.6-0.6-1.5-0.6-2.1,0L2.4,34c-0.6,0.6-0.6,1.5,0,2.1L16,49.6c0.6,0.6,1.5,0.6,2.1,0l2.1-2.1c0.6-0.6,0.6-1.5,0-2.1l-5.6-5.6
        c-0.6-0.7-0.2-1.7,0.7-1.7h33.2c0.7,0,1.5-0.8,1.5-1.6v-33C50,2.8,49.3,2,48.5,2h-3C44.7,2,44,2.8,44,3.5C44,3.5,44,30.5,44,30.5z"
		/>
	</svg>
);

const OrgIcon = () => (
	<svg
		fill="#000000"
		width="24"
		height="24"
		viewBox="0 0 32 32"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M25.469 18h4.531c1.094 0 2 0.906 2 2v10c0 1.094-0.906 2-2 2h-10c-1.094 0-2-0.906-2-2v-10c0-1.094 0.906-2 2-2h3.531v-1.188h-15.094v1.188h3.563c1.094 0 2 0.906 2 2v10c0 1.094-0.906 2-2 2h-10c-1.094 0-2-0.906-2-2v-10c0-1.094 0.906-2 2-2h4.5v-1.875c0-0.688 0.875-1.031 1.656-1.031h6.875v-1.125h-4.313c-1.094 0-2-0.906-2-2v-10c0-1.094 0.906-2 2-2h10c1.094 0 2 0.906 2 2v10c0 1.094-0.906 2-2 2h-3.688v1.156c2.594 0 4.188-0.031 6.781-0.031 0.781 0 1.656 0.313 1.656 1.031v1.875zM30 20h-10v10h10v-10zM20.719 1.969h-10v10h10v-10zM12 20h-10v10h10v-10z" />
	</svg>
);

const SourcingIcon = () => (
	<svg
		fill="#000000"
		version="1.1"
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 256 245"
		enableBackground="new 0 0 256 245"
	>
		<path d="M192.498,113.8c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S183.22,113.8,192.498,113.8z M171.798,155.6c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S162.52,155.6,171.798,155.6z M144.998,192.3h-18.9h-18.9c-11.5,0-18.7,9.5-18.7,21.4V243h12.9v-25.9c0-1.2,1-2,2-2c1.2,0,2,0.8,2,2v25.8h41.5v-25.8c0-1.2,1-2,2-2c1.2,0,2,1,2,2v25.8h12.9v-29.1C163.998,201.8,156.698,192.3,144.998,192.3z M149.698,113.8c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S140.42,113.8,149.698,113.8z M199.098,172.4c0,9.3,7.5,16.8,16.8,16.8s16.8-7.5,16.8-16.8s-7.5-16.8-16.8-16.8S199.098,163.1,199.098,172.4z M197.398,192.3c-11.5,0-18.7,9.5-18.7,21.4V243h12.9v-25.9c0-1.2,1-2,2-2c1.2,0,2,0.8,2,2v25.8h41.5v-25.8c0-1.2,1-2,2-2c1.2,0,2,1,2,2v25.8h12.9v-29.1c0.2-12.1-7.1-21.6-18.7-21.6h-18.9h-19V192.3z M39.798,155.6c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S30.52,155.6,39.798,155.6z M14.798,242.9v-25.8c0-1.2,1-2,2-2c1.2,0,2,0.8,2,2v25.8h41.5v-25.8c0-1.2,1-2,2-2c1.2,0,2,1,2,2v25.8h12.9v-29.1c0.2-12.1-7.1-21.6-18.7-21.6h-18.9h-18.9c-11.5,0-18.7,9.5-18.7,21.4v29.3L14.798,242.9L14.798,242.9z M109.298,172.4c0,9.3,7.5,16.8,16.8,16.8c9.3,0,16.8-7.5,16.8-16.8s-7.5-16.8-16.8-16.8S109.298,163.1,109.298,172.4z M61.298,113.8c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S52.02,113.8,61.298,113.8z M106.698,113.8c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S97.42,113.8,106.698,113.8z M84.098,155.6c9.278,0,16.8,7.522,16.8,16.8s-7.522,16.8-16.8,16.8s-16.8-7.522-16.8-16.8S74.82,155.6,84.098,155.6z M127.933,93c25.038,0,45.5-20.327,45.5-45.5S153.106,2,127.933,2S82.567,22.462,82.567,47.635C82.567,72.673,102.894,93,127.933,93z M125.42,51.359c-8.346-2.917-13.551-7.135-13.551-14.628c0-6.91,4.577-12.34,12.968-14.045v-7.494h6.282v7.135c5.205,0,8.974,1.077,11.756,2.558l-2.558,8.974c-2.064-0.853-5.429-2.288-10.051-2.288c-4.622,0-7.135,2.288-7.135,4.577c0,3.141,2.917,4.353,9.199,6.91c8.571,3.141,12.564,7.494,12.564,14.628s-4.353,12.564-13.551,14.628v7.135h-6.282v-6.91c-5.429,0-10.904-1.436-13.551-2.917l2.288-9.199c2.917,1.436,7.494,3.141,12.34,3.141c5.205,0,7.763-2.288,7.763-5.429S131.433,53.692,125.42,51.359z" />
	</svg>
);

const OperationalIcon = ({ fill = '#000000', width = 24, height = 24 }) => {
	return (
		<svg
			fill={fill}
			width={width}
			height={height}
			viewBox="0 0 100 100"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M39,32H61a2,2,0,0,0,2-2V26a6,6,0,0,0-6-6H43a6,6,0,0,0-6,6v4A2,2,0,0,0,39,32Zm33-7H70a.94.94,0,0,0-1,1v4a8,8,0,0,1-8,8H39a8,8,0,0,1-8-8V26a.94.94,0,0,0-1-1H28a6,6,0,0,0-6,6V74a6,6,0,0,0,6,6H72a6,6,0,0,0,6-6V31A6,6,0,0,0,72,25ZM39,68a2,2,0,0,1-2,2H35a2,2,0,0,1-2-2V66a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H35a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H35a2,2,0,0,1-2-2V46a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2ZM67,68a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V66a2,2,0,0,1,2-2H65a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H65a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V46a2,2,0,0,1,2-2H65a2,2,0,0,1,2,2Z" />
		</svg>
	);
};
const TechMetricsIcon = ({ fill = '#000000', width = 24, height = 24 }) => {
	return (
		<svg
			fill={fill}
			width={width}
			height={height}
			viewBox="0 0 14 14"
			role="img"
			focusable="false"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="m 11.8,10.6 0,-7.2035638 C 11.8,2.7367083 11.264337,2.2 10.603564,2.2 l -7.2071278,0 C 2.7367083,2.2 2.2,2.7356627 2.2,3.3964362 L 2.2,10.6 1,10.6 1,11.2 c 0,0.333681 0.2664272,0.6 0.5950819,0.6 l 10.8098361,0 C 12.726816,11.8 13,11.531371 13,11.2 l 0,-0.6 -1.2,0 z m -8.4,-7.2 7.2,0 0,5.4 -7.2,0 0,-5.4 z m 2.4,6.6 2.4,0 0,0.6 -2.4,0 0,-0.6 z" />
		</svg>
	);
};

const GxpIcon = ({ fill = '#000000', width = 24, height = 24 }) => {
	return (
		<svg
			fill={fill}
			width={width}
			height={height}
			viewBox="0 0 32 32"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M16 1.25c-8.146 0-14.75 6.604-14.75 14.75s6.604 14.75 14.75 14.75c8.146 0 14.75-6.604 14.75-14.75v0c-0.010-8.142-6.608-14.74-14.749-14.75h-0.001zM16 29.25c-7.318 0-13.25-5.932-13.25-13.25s5.932-13.25 13.25-13.25c7.318 0 13.25 5.932 13.25 13.25v0c-0.008 7.314-5.936 13.242-13.249 13.25h-0.001zM16 6.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75c5.385 0 9.75-4.365 9.75-9.75v0c-0.006-5.382-4.368-9.744-9.749-9.75h-0.001zM16 24.25c-4.556 0-8.25-3.694-8.25-8.25s3.694-8.25 8.25-8.25c4.556 0 8.25 3.694 8.25 8.25v0c-0.006 4.554-3.696 8.245-8.249 8.25h-0.001zM16 11.25c-2.623 0-4.75 2.127-4.75 4.75s2.127 4.75 4.75 4.75c2.623 0 4.75-2.127 4.75-4.75v0c-0.003-2.622-2.128-4.747-4.75-4.75h-0zM16 19.25c-1.795 0-3.25-1.455-3.25-3.25s1.455-3.25 3.25-3.25c1.795 0 3.25 1.455 3.25 3.25v0c-0.002 1.794-1.456 3.248-3.25 3.25h-0z" />
		</svg>
	);
};
const ConfirmIcon = ({ width = 40, height = 40, stroke = '#000000' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.5 12.5L5.57574 16.5757C5.81005 16.8101 6.18995 16.8101 6.42426 16.5757L9 14"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M16 7L12 11"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M7 12L11.5757 16.5757C11.8101 16.8101 12.1899 16.8101 12.4243 16.5757L22 7"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export {
	InstructionsIcon,
	SelectMultipleIcon,
	Intro,
	OrgIcon,
	SourcingIcon,
	OperationalIcon,
	TechMetricsIcon,
	GxpIcon,
	ConfirmIcon,
};
